module.exports = __webpack_public_path__ + "img/logo-white.89b29d8.svg";